const countries = window.theme?.locales?.country_list;
const current_locale = window.Shopify.locale+ '-' + window.Shopify.country.toLowerCase()

/**
 * Hide the modal dialog
 */
function ip_modal_hide() {
  sessionStorage.ip_modal_visibility = 'true';

  document.querySelector('.ip_modal_frame').classList.add('ip-modal-hidden');
  document.querySelector('.ip_modal_background').classList.add('ip-background-hidden');
}

/**
 * Show the modal dialog for a specific country
 *
 * @param {string} country The ISO 3166-1 2 letter country code for which to show the dialog for
 */
function ip_modal_show(newLocales) {
  const ip_modal = document.querySelector('.ip_modal');
  const country_name = newLocales[0].country;
  const title = ip_modal.querySelector('.ip_modal_title').innerHTML
  let title_html = title + `${country_name}`;
  const default_btn = ip_modal.querySelector('.default-btn');
  let primary_button_text = default_btn.innerHTML
  let primary_button_html = primary_button_text + `${country_name}`;
  let multiple_countries = newLocales.length > 1 ? true : false;
  if(multiple_countries) {
    const lang_1_btn = ip_modal.querySelector('.lang_1')
    const lang_2_btn = ip_modal.querySelector('.lang_2')
    let lang1 = newLocales[0].language
    let lang2 = newLocales[1].language
    let country_0_button_html = lang_1_btn.innerHTML + `${lang1}`;
    let country_1_button_html = lang_2_btn.innerHTML + `${lang2}`;
    lang_1_btn.innerHTML = country_0_button_html;
    lang_2_btn.innerHTML = country_1_button_html;
  }
  document.querySelector('.ip_modal_title').innerHTML = title_html;
  default_btn.innerHTML = primary_button_html;
  document.querySelector('.ip_modal_frame').classList.add('ip-modal-visible');
  document.querySelector('.ip_modal_background').classList.add('ip-background-visible');
}

/**
 * Returns a string "true" if the ipmodal should be shown
 *
 * @returns {string}
 */
function get_ip_modal_cookie() {
  if (sessionStorage.ip_modal_visibility === 'true') { return 'true'; } return '';
}

function diff_lang(locale_string) {
  let root_url = window.theme?.routes?.rootUrl;
  root_url = root_url?.slice(1);
  let current_lang = window.Shopify.locale;
  if(locale_string != '' && locale_string !== current_lang) return true;
  return false;
}

/**
 * Returns a destination url based on current settings
 * current locale from shopify 'en-us', etc
 * countryObject from shop.metafields.constant.country_list, object with locale_url and currency info
 * mutipleLocales Boolean - multiple countries means to pass in only the locale ('/de or /fr to URL)
 * @returns {string}
 */
function get_url(countryObject) {
  let locale_url = countryObject.locale_url;
  let root_url = window.theme.routes.rootUrl;
  
  let url = `${window.theme.shop.us_modal_production}`;
  if (window.Shopify.shop.includes('stage')) {
    url = `${window.theme.shop.us_modal_staging}`;
  }
  let store = countryObject.store;
  if (store === 'UK') {
    // UK urls
    url = `${window.theme.shop.uk_modal_production}`;
    if (window.Shopify.shop.includes('stage')) {
      url = `${window.theme.shop.uk_modal_staging}`;
    }
  }
  else if (store === 'EU') {
    // eu urls
    url = `${window.theme.shop.eu_modal_production}`;
    if (window.Shopify.shop.includes('stage')) {
      url = `${window.theme.shop.eu_modal_staging}`;
    }
  }
  if (locale_url.length > 1) {
    url += `/${locale_url}`;
  }
  if(url == root_url) {
    url = false;
  }
  return url
}

const handleClick = (url) => {
  
  if(!url) {
    ip_modal_hide();
  }
  else {
    sessionStorage.ip_modal_visibility = 'true';
    window.location.href = url;
  }
  
};

async function callIP(url) {
  const ipapi_call = new XMLHttpRequest();

  return new Promise((resolve, reject) => {
      ipapi_call.open('GET', url, true); // Third parameter true makes it async

      let dest_url = '';
      let ip_json = '';
      const modal = document.querySelector('.ip_modal')
      const default_btn = modal.querySelector('.default-btn');
      const close_btn = modal.querySelector('.close');

      ipapi_call.onload = function () {
        if (this.status === 200) {
          ip_json = JSON.parse(this.responseText);

          if (typeof (ip_json.countryCode !== 'undefined')) {
            //get ip country code of current user
            const countryCode = ip_json.countryCode;
            const newLocales = countries?.filter(country => country.country_code === countryCode);
            const firstLocale = newLocales ? newLocales[0] : null;
            const multipleLocales = newLocales?.length > 1 ? true : false;

            if (firstLocale) {
              const new_locale = firstLocale.locale_url;
              let differentCountry = countryCode.toLowerCase() !== window.Shopify.country.toLowerCase();
              let differentLang = diff_lang(new_locale);
              if (differentCountry || differentLang || newLocales?.length > 1) {
                
                let dest_url = get_url(firstLocale);
                let current_href = window.location.href;
                if (current_href?.indexOf(dest_url) !== -1) {
                  hide_ip_modal();
                  return;
                }
                // if we have a cookie that turned off the modal already, don't show the modal
                const ip_modal_visibility = get_ip_modal_cookie(`ip_modal_visibility_${current_locale}`);
                if (ip_modal_visibility === '') {
                  document.querySelector('.ip_modal_background')?.addEventListener('click', ip_modal_hide);
                  default_btn?.addEventListener('click', () => { window.location.href = dest_url; });
                  close_btn?.addEventListener('click', ip_modal_hide);

                  if(multipleLocales) {
                    const secondLocale = newLocales[1]
                    const new_lang_div = modal.querySelector('.ip_modal_multiple_languages');
                    const lang1Button = new_lang_div.querySelector('.lang_1');
                    const lang2Button = new_lang_div.querySelector('.lang_2');
                    let dest_url_2 = get_url(secondLocale)
                    new_lang_div?.style.setProperty('display','block');
                    default_btn?.style.setProperty('display', 'none');
                    lang1Button?.addEventListener('click', () => handleClick(dest_url));
                    lang2Button?.addEventListener('click', () => handleClick(dest_url_2));
                  }
                  ip_modal_show(newLocales);
                }
              } else {
                console.log('ip-api: no modal');
              }
            } else { // country code not found in table
              console.error(`ip-api: Country code not supported. ${countryCode}`);
            }
          } else { // no country code defined in JSON
            console.error('ip-api: no IP address found.');
          }
        } else { // JSON returned bad status
          console.error(`ip-api: no IP address found. ${this.status}`);
        }
      };

      ipapi_call.onerror = () => {
          reject(new Error('Network error occurred'));
      };

      ipapi_call.send();
  });
}

const getIPInfo = async () => {
  try {
    let url = 'https://pro.ip-api.com/json?key=hMiilpfECMHjB77';
      const response = await callIP(url);
  } catch (error) {
      console.error(error);
  }
};
 document.addEventListener("DOMContentLoaded", () => {
  getIPInfo();
})
